export const Events = {
  BASIC_DETAILS: {
    submitEvent: {
      EVENTNAME: "Profile Section Saved",
      EVENTOBJ: {
        sectionName: "Basic Details",
        sourceOfUpdate: "Apply Apop",
      },
    },
  },
  EDUCATION_DETAILS: {
    submitEvent: {
      EVENTNAME: "Profile Section Saved",
      EVENTOBJ: {
        sectionName: "Educational Details",
        sourceOfUpdate: "Apply Apop",
      },
    },
  },
  EMPLOYMENT_DETAILS: {
    submitEvent: {
      EVENTNAME: "Profile Section Saved",
      EVENTOBJ: {
        sectionName: "Employment Details",
        sourceOfUpdate: "Apply Apop",
        pageName: "seeker/pro",
      },
    },
  },
  JOB_PREFERENCES: {
    submitEvent: {
      EVENTNAME: "Profile Section Saved",
      EVENTOBJ: {
        sectionName: "Job Preferences",
        sourceOfUpdate: "Apply Apop",
      },
    },
  },
  LGBTQ: {
    submitEvent: {
      EVENTNAME: "Profile Section Saved",
      EVENTOBJ: {
        sectionName: "LGBTQ Details",
        sourceOfUpdate: "Apply Apop",
      },
    },
  },
  RESUMEANDEMPLOYMENT: {
    resumeUpload: {
      EVENTNAME: "Profile Nudge Application Flow",
      EVENTOBJ: {
        uploadResume: "Yes",
      },
    },
    confirmInfo: {
      EVENTNAME: "Profile Nudge Application Flow",
      EVENTOBJ: {
        uploadResume: "No",
        typeOfUpdate: "Confirm",
        autoUpdate: "Yes",
        salaryNotice: "Yes",
        fresher: "No",
      },
    },
    editInfo: {
      EVENTNAME: "Profile Nudge Application Flow",
      EVENTOBJ: {
        uploadResume: "No",
        typeOfUpdate: "Edit & Update",
        autoUpdate: "Yes",
        salaryNotice: "Yes",
        fresher: "No",
      },
    },
  },
  VERIFICATION: {
    verified: {
      EVENTNAME: "Profile Nudge Application Flow",
      EVENTOBJ: {
        fieldUpdated: "Contact Verified",
      },
    },
    addAndVerified: {
      EVENTNAME: "Profile Nudge Application Flow",
      EVENTOBJ: {
        fieldUpdated: "Contact Added & Verified",
      },
    },
    updateAndVerify: {
      EVENTNAME: "Profile Nudge Application Flow",
      EVENTOBJ: {
        fieldUpdated: "Contact Updated and Verified",
      },
    },
  },
  LINKED_IN: {
    linkedInAdded: {
      EVENTNAME: "Linkedin_added_DB",
      EVENTOBJ: {
        section_name: "L1 a-pop",
        type_of_save: "add",
      },
    },
    linkedInClick: {
      EVENTNAME: "Linkedin_save_click",
      EVENTOBJ: {
        section_name: "L1 a-pop",
        type_of_save: "add",
      },
    },
  },
};
